import React from 'react';

import { Box, Typography } from '@mui/material';

import emptyJobsIllustration from './assets/empty-jobs-illustration.svg';
import { FONT_FAMILY, NEUTRAL_300 } from './colors';

const EmptyJobsState = () => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '64px 0'
    }}
  >
    <img alt="" height={120} src={emptyJobsIllustration} width={120} />
    <Typography
      sx={{
        color: NEUTRAL_300,
        fontFamily: FONT_FAMILY,
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '20px',
        textAlign: 'center'
      }}
    >
      Unfortunately, there are no jobs available
    </Typography>
  </Box>
);

export default EmptyJobsState;
